// extracted by mini-css-extract-plugin
export default {"stopsNeedle":"RoutesTable_stopsNeedle__ZDMku","initials":"RoutesTable_initials__x8S84"};